module.exports = __webpack_public_path__ + "img/Airplane.25553cbf.svg";